module.exports = __webpack_public_path__ + "img/93978.a2371361.svg";